import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  authorNameTitle: FelaCSS;
  headerContainer: FelaCSS;
  viewAllText: FelaCSS;
}

const styles = (): IStyles => ({
  authorNameTitle: {
    fontDefaultSemiBold: 24,
    marginBottom: 4,
  },
  headerContainer: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  viewAllText: {
    fontDefault: 16,
    cursor: 'pointer',
    marginRight: 2,
    ':hover': {
      textDecoration: 'underline',
    },
  },
});

export default styles;
